import { TFunc } from 'libs/i18n';
import {
  parseAddressValue,
  parseTaxResidencesValue,
  parsePepConnectionInitialValue,
} from 'modules/client/common/helpers';

import { LegalClientHeadFormType } from '../../forms/legalClientHeadForm';
import { LegalClientHeadPositionFormType } from '../../forms/positionInCompanyForm';

export const getLegalClientHeadInitialValue = (
  t: TFunc
): LegalClientHeadFormType => ({
  reasonChange: { reason: '' },

  personalData: {
    email: '',
    firstName: '',
    lastName: '',
    middleName: '',
    dateOfBirth: undefined,
  },

  citizenships: [null],

  taxResidences: parseTaxResidencesValue(),

  registrationAddress: parseAddressValue(),
  residentialAddress: parseAddressValue(),

  placeOfBirth: {
    country: null,
    locality: '',
  },

  pepConnection: parsePepConnectionInitialValue(undefined, t),

  position: {
    headType: null,
    position: '',
    positionConfirmationFiles: [],
    body: null,
  } as LegalClientHeadPositionFormType['position'],
});
